import { render, staticRenderFns } from "./designationAgentForm.vue?vue&type=template&id=3fe7b33e&"
import script from "./designationAgentForm.vue?vue&type=script&lang=js&"
export * from "./designationAgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe7b33e')) {
      api.createRecord('3fe7b33e', component.options)
    } else {
      api.reload('3fe7b33e', component.options)
    }
    module.hot.accept("./designationAgentForm.vue?vue&type=template&id=3fe7b33e&", function () {
      api.rerender('3fe7b33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/designationAgentForm.vue"
export default component.exports